<template>
	<div>
		<span class="mediumName" :style="bottonStyle" v-if="this.id">{{mediumName}}</span>
	</div>
</template>
<script>
export default {
	props: ['mediumName', 'mediumId'],
	watch: {
		mediumId: {
			immediate: true,
			deep: true,
			handler(val) {
				this.id = val;
			},
		},
	},
	computed: {
		bottonStyle() {
			return {
				...this.list[this.id],
			};
		},
	},
	data() {
		return {
			id: '',
			list: {
				401: {
					color: '#5E9DF8',
					background: '#EDF5FE',
					border: '1px solid #5E9DF8',
				},
				402: {
					color: '#51C51A',
					background: '#E4FEDA',
					border: '1px solid #51C51A',
				},
				403: {
					color: '#FDB203',
					background: '#FFF7DD',
					border: '1px solid #FDB203',
				},
				404: {
					color: '#4368B2',
					background: 'rgba(147, 181, 248, 0.4)',
					border: '1px solid #4368B2',
				},
				405: {
					color: '#9E64EE',
					background: '#F9F0FF',
					border: '1px solid #9E64EE',
				},
        406: {
					color: '#FF9FA5',
					background: '#FADDDF',
					border: '1px solid #FF9FA5',
				},
			},
		};
	},
	methods: {},
	components: {},
};
</script>
<style lang="scss" scoped>
.mediumName {
	display: inline-block;
	padding: 2px 10px;
	border-radius: 4px;
	font-size: 12px;
}
</style>
